import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { FlightsFacade } from "../../../data-access/services/flights.facade";
import { ActivatedRoute, Router } from "@angular/router";
import { PagesRoute } from "src/app/pages/src/app/ui/routes/routes.enum";
import { CheckoutFacade } from "src/app/libs/data-access/services/checkout/services/checkout.facade";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "tic-flight-result",
  templateUrl: "./flight-result.component.html",
  styleUrls: ["./flight-result.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class FlightResultComponent {
  @Output() onSelectedFlight: EventEmitter<any> = new EventEmitter();
  @Input() flightOffer: any;
  @Input() parseDuration!: Function;
  @Input() parseLocation!: Function;
  @Input() showBookingButton: boolean = true;
  checked: boolean = false;
  @Input() isSummary: boolean = false;
  private destroy$ = new Subject();
  
  constructor(public facadeCheckout: CheckoutFacade,public facade: FlightsFacade, private route: ActivatedRoute, private router: Router) {}

  ngOnInit() {
    this.setInitialState();
  }

  setInitialState() {
    // if(this.router.url.includes('trip-summary')) {
    //   this.isSummary = true;
    // }
    // this.route.queryParams.subscribe(params => {
    //   if( params['flightId'] == this.flightOffer["id"] ) {
    //     this.checked = true;
    //   }
    // });

    this.facadeCheckout.flight$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if( data["id"] == this.flightOffer["id"] ) {
        this.checked = true;
      }
    })
  }

  onSelectedFlightOffer(): void {
    this.onSelectedFlight.emit({
      flightOfferId: this.flightOffer["id"],
      flightOfferPrice: this.flightOffer["actual_amount"],
      flightOfferPriceCurrency: this.flightOffer["total_currency"],
    });
  }
  
  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
